import { useEffect, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { id: "services", label: "Services" },
  { id: "impact", label: "Impact" },
  { id: "work", label: "Case Studies" },
  { id: "samples", label: "Work Samples" },
  { id: "blog", label: "Blog" },
];

export function scrollToId(id, navigate, pathname) {
  const doScroll = () => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
    else el.scrollIntoView({ behavior: "smooth" });
  };
  if (pathname !== "/") {
    navigate("/");
    setTimeout(doScroll, 400);
  } else {
    doScroll();
  }
}

export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id, navigate, pathname);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "glass py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 lg:px-8">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-3">
          <img src="/dna-logo.png" alt="DNA eCommerce Ads" className="h-9 w-auto" />
        </Link>

        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm font-medium text-muted transition-colors hover:text-white"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="header-cta"
          onClick={() => go("audit")}
          className="hidden rounded-full bg-white px-5 py-2.5 text-sm font-semibold text-ink transition-transform hover:scale-105 lg:inline-flex"
        >
          Get a Free Audit
        </button>

        <button className="lg:hidden text-white" onClick={() => setOpen((o) => !o)} data-testid="mobile-menu-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="glass mt-3 mx-4 rounded-xl p-4 lg:hidden" data-testid="mobile-menu">
          <div className="flex flex-col gap-3">
            {LINKS.map((l) => (
              <button key={l.id} data-testid={`mobile-nav-${l.id}`} onClick={() => go(l.id)} className="text-left text-sm text-muted hover:text-white">
                {l.label}
              </button>
            ))}
            <button data-testid="mobile-header-cta" onClick={() => go("audit")} className="mt-2 rounded-full bg-gradient-to-r from-orange to-magenta px-5 py-2.5 text-sm font-semibold text-white">
              Get a Free Audit
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
